import "./Shoes.css"
import Product1 from "../Components/Product1"
import Frames1 from "../images/frame1.webp"
import Frames2 from "../images/frame2.webp"
import Frames3 from "../images/frame3.webp"
import Frames4 from "../images/frame4.webp"
import Frames5 from "../images/frame5.webp"
import Frames6 from "../images/frame6.webp"
import Frames7 from "../images/frame7.webp"
import Frames8 from "../images/frame8.webp"
import Frames9 from "../images/frame9.jpg"


export default function Shoes() {

  return (
    <div className="stdivinhome">
      <div className="add"><img src={Frames9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="frame1"prdName="COMBO-FRAME" img={Frames1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="frame2" prdName="SINGLE FRAMES" img={Frames2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1> 

          </div>

          <div className="home__prd1">

          
          <Product1  id="frame3"prdName="SET FRAMES" img={Frames3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="frame4"prdName="COMBO " img={Frames4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="frame5"prdName="SINGLE A4 FRAME" img={Frames5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1  id="frame6"prdName="A4 FRAMES" img={Frames6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1  id="frame7" prdName="TREE FRAME CLUB" img={Frames7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="frame8"prdName="SET FRAMES" img={Frames8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}